import { useMemo } from 'react';
import { usePresenceActions } from './PresenceProvider';
import type { CollaborationPresence } from './PresenceProvider';

export function useCollaboratorSelections() {
  const { others } = usePresenceActions();

  return useMemo(() => {
    const selectedRows = new Map<string, string>();
    for (const presence of others as CollaborationPresence[]) {
      if (presence.selectedRowId) {
        selectedRows.set(String(presence.selectedRowId), presence.color ?? 'var(--ds-color-border-primary)');
      }
    }
    return selectedRows;
  }, [others]);
}
